<template>
    <el-drawer
        title="授权班级"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="600px"
        :before-close="close">
        <!-- <div class="mask" v-if="authorize">
        	<div style="margin-top: 150px;margin-left: 100px;opacity: 0.7;">
        		<img src="./watermark.png" style="height: 400px;width: 400px;" />
        		<br/>
        		<h1 style="opacity: 0.7;width: 400px;text-align: center;">暂未授权,请联系相关工作人员</h1>
        	</div>
        </div> -->
        <div class="panel fx-g1">
            <el-checkbox-group v-model="systemClasses" class="fx fx-wrap fx-m_between fx-c_center">
                <el-checkbox v-for="item in allClasses" :key="item.id" :label="item.id"
                    style="margin: 10px 30px 10px 0">{{item.name}}</el-checkbox>
            </el-checkbox-group>

        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
.mask {
    	position: absolute;
    	top: 50px;
    	left: 0;
    	right: 0;
    	bottom: 0;
    	/* height:100%; */
    	background-color: #ffffff99;
    	/* 半透明遮罩层 */
    	/* pointer-events: none; */
    	/* 鼠标事件不被遮罩层捕获，直接传递到底层 */
    	z-index: 10;
    }
</style>


<script>


    export default {
        props: [
            "item",
        ],
        data() {
            return {
                // authorize:true,
                show: false,
                allClasses: [],
                systemClasses: [],
            }

        },


        methods: {
            // getAuthorize(){
            //     this.$ajaxGet("/lesson/getAuthorize/"+this.item.id, (data) => {
            //         this.authorize = data.result;
            //     })
            // },
            close() {

                this.$emit("close");
            },
            sub() {
                this.$ajaxPost("/class/updateLessonSystemByBatch", {
                    classIds: this.systemClasses,
                    lessonSystemId: this.item.id
                }, data => {
                    this.$showSuccess("保存成功", 1200, ()=> {
                        this.close();
                    })
                })
                return false;
            },
            loadAllClasses() {
                console.debug(this.item);
                this.$ajaxPost("/class/list", {
                    form: {
                        useType: this.item.useType == 2 ? 2 : 0, //如果体系是收费体系，那么只出收费班级，否则出所有班级
                        enable: true,
                        hasEnable:true
                    }
                }, (data) => {
                    this.allClasses = data.result;
                })
            },
            loadSystemClasses() {
                this.$ajaxGet("/class/getClassIdsByLessonSystem/" + this.item.id, data => {
                    this.systemClasses = data.result;
                })
            }
        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadAllClasses() ;
            this.loadSystemClasses();
            // this.getAuthorize();
        }


    }
</script>
